<template>
  <div>
    <div v-if="$auth.setting && $auth.setting.is_vendor_listing == true">
      <NavbarMultiVendor :page="page" :checkpage="checkpage" :settingData="settingData"
        :singleRestaurant="singleRestaurant" @toggleNavCart="navtoggleCart" @getLatLong="emitLatLong"
        @sendDefaultAddress="handleDefaultAddress" @isDelivery="handleDeliveryChange" @storeModal="closeStoreModal" />
    </div>
    <div v-else-if="$auth.setting && $auth.setting.is_vendor_listing == false">
      <NavbarSingleVendor :page="page" :checkpage="checkpage" :settingData="settingData"
        :singleRestaurant="singleRestaurant" @toggleNavCart="navtoggleCart" @getLatLong="emitLatLong"
        @sendDefaultAddress="handleDefaultAddress" @isDelivery="handleDeliveryChange" @storeModal="closeStoreModal" />
    </div>
    <div v-else></div>
  </div>
</template>

<script>
import NavbarMultiVendor from './NavbarMultiVendor.vue';
import NavbarSingleVendor from './NavbarSingleVendor.vue';

export default {
  components: {
    NavbarMultiVendor,
    NavbarSingleVendor
  },
  props: ["page", "checkpage", "settingData", "singleRestaurant"],
  methods: {
    navtoggleCart() {
      this.$emit("toggleNavCart", "yes");
    },
    emitLatLong(data) {
      this.$emit("getLatLong", data);
    },
    handleDefaultAddress(address) {
      this.$emit("sendDefaultAddress", address);
    },
    handleDeliveryChange(value) {
      this.$emit("isDelivery", value);
    },
    closeStoreModal() {
      this.$emit("storeModal");
    }
  }
}
</script>